module.exports = __webpack_public_path__ + "img/kz.2052e1a5.svg";